import React from 'react';
import axios from 'axios';
import {BASE_URL_OSLOG} from "../../constants/ActionTypes";

class EmbeddMapMonitoring extends React.Component {
    signInToOslogJyoti = async(username, password) => {
        const URL = `${BASE_URL_OSLOG}/embedd/auth?username=${username}&password=${password}&embedd=true`;
        console.log(URL)
    
        return await axios({
            headers: {
                'Accept': 'application/json',
            },
            method: 'get',
            url: URL,
            withCredentials: true,
        }).then((response) => response).catch((error) => error.response);
    }

    async componentWillMount() {
        const { search } = this.props.location;
        const params = new URLSearchParams(search);
        const username = params.get('username');
        const password = params.get('password');
        await this.signInToOslogJyoti(username, password)
        window.location = `${BASE_URL_OSLOG}/embedd/tracking/mapMonitoring`;
    };

    render() {
        return (
            <div></div>
        );
    }
}

export default EmbeddMapMonitoring;


// WEBPACK FOOTER //
// ./containers/EmbeddMapMonitoring/index.js